import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { recuperarConfigUsuari } from '../../actions/configUsuariAction';
import { recuperarHistorialAdminPaginat } from '../../actions/configAppAction';
import { ModificarScreen } from '../register/ModificarScreen';
import { CercaTableADMIN } from './Tabla/CercaTableADMIN';
import { GestioUsuaris }   from './GestioUsuaris';
import { GestioMunicipis } from './GestioMunicipis';
import { uiFinalitzarFormularioAction } from '../../actions/ui';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ca';

export const MenuPrincipalADMIN = ({ vista, onCambiarVista }) => {
    const dispatch  = useDispatch();
    const [t]       = useTranslation("generic");
    const { auth, configUsuari } = useSelector(state => state);
    const [year]    = useState(moment().format('YYYY'));

    useEffect(() => {
        dispatch(recuperarConfigUsuari(auth.tokenJwt));
        dispatch(uiFinalitzarFormularioAction());
        dispatch(recuperarHistorialAdminPaginat(auth.tokenJwt));
    }, [auth]);

    return (
        <>
            {configUsuari.contingut != null ? <ModificarScreen /> : null}

            {vista === 'historial'  && (
                <div>
                    <div style={{ marginBottom: 28 }}>
                        <p className="ca-label-super">Panel</p>
                        <h2 className="ca-h2">{t("Menu.title")} {year}</h2>
                        <p className="ca-subtext">Historial de evaluaciones de todos los municipios</p>
                    </div>
                    <CercaTableADMIN />
                </div>
            )}

            {vista === 'usuarios'   && <GestioUsuaris />}
            {vista === 'municipios' && <GestioMunicipis />}
        </>
    );
};

